import { render, staticRenderFns } from "./spc_entity_link_analyzer.vue?vue&type=template&id=156f229a&scoped=true"
import script from "./spc_entity_link_analyzer.vue?vue&type=script&lang=js"
export * from "./spc_entity_link_analyzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f229a",
  null
  
)

export default component.exports